'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var propTypes = require('prop-types');
const i18NPropTypeChecker = propTypes.shape({
  pgettext: propTypes.func.isRequired,
  npgettext: propTypes.func.isRequired,
  gettext: propTypes.func.isRequired,
  ngettext: propTypes.func.isRequired,
  translations: propTypes.shape({}).isRequired,
  jsx: propTypes.shape({
    pgettext: propTypes.func.isRequired,
    npgettext: propTypes.func.isRequired,
    gettext: propTypes.func.isRequired,
    ngettext: propTypes.func.isRequired
  }).isRequired
});
exports.i18NPropTypeChecker = i18NPropTypeChecker;
